/*
    Display for an individual queued message,
    with the option to expand to show an edit form,
    and a checkbox to mark as selected for group actions,
    split into media queries for different screen sizes
*/

import React from "react";
import Media from "react-media";

import MessageGeneralForm from "../Forms/MessageGeneralForm";
import StyledCheckbox from "../Components/StyledCheckbox";

import DataItem from "../Components/DataItem";

/*
    serviceType: "TTS and Scrolling Text",
    locationsSelected: ["CAMD", "PABT"],
    routesSelected: [],
    lanesSelected: [],
    ASAType: "",
    ASAData: null,
    startDate: new Date("10/22/2020"),
    endDate: new Date("11/25/2020"),
    validStartTime: "10:05",
    validEndTime: "15:30",
    daysOfWeek: [2,3,5,6],
    minuteInterval: "5",
    repetitionNumber: "2"

    direction: "I"
    emissions: "1"
    enable: "true"
    enddate: "11/14/2018 12:00:00 AM"
    endtime: null
    frequency: "1234567"
    groupid: "NLR"
    interval: "3"
    lane: ""
    messageID: "6"
    phrase: "testing123"
    route: ""
    service_type: "1"
    startdate: "4/14/2016 2:45:00 PM"
    starttime: null
    terminal: "ALL"
*/

export default class MessageGeneralData extends React.Component {

    // "select" this element for group actions with other message data records
    onSelect = () => {
        this.props.onSelect(this.props.containerIndex);
    }

    render() {

        const data = this.props.data;

        console.log("MESSAGE GENERAL PROPS", this.props, data);

        let selected = false;

        // if we're expanded, there's only one block to display
        // if not, then we need a small column for the select checkbox
        const gridTemplateColumns = this.props.expanded ? "1fr" : "1fr 30fr";

        if(this.props.selectedList.includes(this.props.containerIndex)){
            selected = true;
        }

        let className = "data";

        if(!this.props.expanded){
            className += " shadow-card";
        }

        return (
            <div className={className} style={
                {display:"grid",
                gridTemplateColumns,
                borderTopRightRadius:"5px",
                borderBottomRightRadius:"5px"
                }
            }>
            {
                this.props.expanded 
                ? <div className="data-expanded vertical" style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"           
                }}>
                    <MessageGeneralForm data={this.props.data} submit={this.props.updateMessage} index={this.props.containerIndex} locationLookup={this.props.locationLookup} />
                    <div className="option option-low-vertical"
                        style={{
                            alignSelf:"flex-end",
                            justifySelf:"flex-end",
                            margin: "6px",
                            marginRight: "12px"
                        }}
                        onClick={() => this.props.runOpen(null)}
                    >
                        Close
                    </div>
                </div>
                : <><div className="data-multiselect" style={{
                        backgroundColor: selected ? "var(--red)" : "var(--light-gray)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }} onClick={this.onSelect}>
                        <StyledCheckbox checked={selected} onChange={this.onSelect} />
                    </div>
                <div style={{
                        padding: "8px 0 8px 32px"
                    }}  
                    onClick={() => this.props.runOpen(this.props.containerIndex)}
                >
                    <Media query="(max-width: 811px)">
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gridGap: "4px",
                            marginBottom: "8px"
                        }}>
                            <div style={{display:"flex"}}>
                                <span>Dates:&nbsp;</span> 
                                <div style={{display:"flex", flexDirection:"column"}}>
                                    <DataItem val={`${data.startdate} - `} />
                                    <DataItem val={data.enddate} />
                                </div>
                            </div>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr"
                            }}>
                                <div>Days: <DataItem val={data.frequency} /></div>
                                <div>Interval: <DataItem val={data.interval} /></div>
                                <div>
                                </div>
                                <div>Repetitions: <DataItem val={data.emissions} /></div>
                                <div>Direction: <DataItem val={data.direction} /></div>
                                <div>Enabled: <DataItem val={data.enable} /></div>
                            </div>
                        </div>
                    </Media>
                    <Media query="(min-width: 812px)">
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 5fr",
                            marginBottom: "4px"
                        }}>
                            <div style={{display:"flex"}}>
                                <span>Dates:&nbsp;</span> 
                                <div style={{display:"flex", flexDirection:"column"}}>
                                    <DataItem val={`${data.startdate} - `} />
                                    <DataItem val={data.enddate} />
                                </div>
                            </div>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "2fr 1fr 1fr 1fr"
                            }}>
                                <div>
                                </div>
                                <div>Days: <DataItem val={data.frequency} /></div>
                                <div>Interval: <DataItem val={data.interval} /></div>
                                <div>Repetitions: <DataItem val={data.emissions} /></div>
                                <div></div>
                                <div>Direction: <DataItem val={data.direction} /></div>
                                <div>Enabled: <DataItem val={data.enable} /></div>
                            </div>
                        </div>
                    </Media>
                    <div style={{display:"flex", margin:"4px 0"}}>
                        Phrase:&nbsp;<DataItem val={data.phrase} />
                    </div>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        marginBottom: "4px"
                    }}>
                        <div style={{display: "grid", gridTemplateColumns: "1fr"}}>
                            <div>Locations: </div>
                            {
                                data.terminal.split(",").filter(x => x).map((loc, index) => {
                                    return <div className="multiselected" key={index}>{this.props.locationLookup[loc]}</div>
                                })
                            }
                        </div>
                        <div style={{display: "grid", gridTemplateColumns: "1fr 2fr"}}>
                            <div>Routes: </div>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr"
                            }}>
                            {
                                data.route.split(",").filter(x => x).map((route, index) => {
                                    return <div className="multiselected" key={index}>{route}</div>
                                })
                            }
                            </div>
                        </div>
                        <div style={{display: "grid", gridTemplateColumns: "1fr 2fr"}}>
                            <div>Lanes: </div>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr"
                            }}>
                            {
                                data.lane.split(",").filter(x => x).map((lane, index) => {
                                    return <div className="multiselected" key={index}>{lane}</div>
                                })
                            }
                            </div>
                        </div>
                    </div>
                </div>
                </>
            }
            </div>
        )
    }
}